/**
 * @description 网页跳转事件
 * @author wangfupeng
 */

import { URL_PARAMS } from './params'

/**
 * 跳转
 * @param {Object} eventData 事件配置
 */
export default function (eventData = {}) {
    const location = window.location
    const url = eventData.target
    if (!url) {
        console.error('target url is null or undefined')
        return
    }

    // 手机号、邮箱、onetravel、diditravel协议直接跳转
    if (/^(globalonetravel|onetravel|diditravel|tel|mailto).*/i.test(url)) {
        location.href = url
        return
    }
    const urlParams = URL_PARAMS()
    // ------------ 处理 dchn 参数 begin (wangfupeng) ------------
    // 获取当前 url 的 dchn 参数。多个参数值可能是数组形式，如 dchn=[aaa,bbb,ccc]
    const dchn = urlParams.dchn || ''
    // 万一是 dchn=[aaa,[bbb,ccc]] 形式，要将其 flat
    let dchnArr = dchn.match(/[A-Za-z0-9]+/g) || []
    // 获取将要跳转的目标页面的 dchn 参数，并将其插入到现有数组之前（必须是插入到之前！！！）
    const targetDchn = K.query.get('dchn', url)
    if (targetDchn != null) {
        // 注意，万一 targetDchn 也是 [aaa,[bbb,ccc]] 形式
        const targetDchnArr = targetDchn.match(/[A-Za-z0-9]+/g) || []
        dchnArr = targetDchnArr.concat(dchnArr)
    }
    // 变为字符串
    let newDchn = ''
    if (dchnArr.length === 1) {
        // 一个渠道号
        newDchn = dchnArr[0]
    } else if (dchnArr.length > 1) {
        // 多个渠道号
        newDchn = `[${dchnArr.join(',')}]`
    }
    // 重新赋值
    urlParams.dchn = newDchn
    //  ------------ 处理 dchn 参数 end ------------

    const newUrl = K.query.build(url, urlParams)
    location.href = newUrl
}
